const savedHash = window.location.hash;
if (savedHash) {
  window.location.hash = ''; 
}

$(document).ready(function($){

  $(window).on('resize', function(e) {
    var resizeTimer;
    var width = $(window).width(), height = $(window).height();
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      Shopify.theme.objectFitImages.calculateAspectRatio();

      // Only run if window has actually been re-sized
      if($(window).width() != width || $(window).height() != height){
        if (
                window.Shopify &&
                Shopify.theme &&
                Shopify.theme.jsProduct &&
                typeof Shopify.theme.jsProduct.disableSlideshow === 'function'
            ) {
              Shopify.theme.jsProduct.disableSlideshow(null, $('.product-gallery__main:not([data-quickshop-gallery]), .product-gallery__thumbnails:not(.js-gallery-carousel)'));
              Shopify.theme.jsProduct.enableSlideshow($('.product-gallery__main:not([data-quickshop-gallery]), .product-gallery__thumbnails:not(.js-gallery-carousel)'));
            }
      }


      if (!isScreenSizeLarge()){

        // When 798 or less
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.init();

      } else {

        // When larger than 798
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.unload();
        Shopify.theme.jsHeader.init($('.jsHeader'));

        // Swatches
        if(Shopify.theme_settings.product_form_style == 'swatches') {
          Shopify.theme.thumbnail.enableSwatches();
        }
      }

    }, 250);

  });  
  function observeKlaviyoButton() {
      const targetNode = document.body; 
      const observer = new MutationObserver(function(mutationsList) {
          mutationsList.forEach(function(mutation) {
            const button = $('.go300628013');
            if (button.length > 0 && !button.closest('.st-btn').length) {
                button.wrap('<div class="st-btn"></div>').after('<span></span>');
                observer.disconnect();
            }
          });
      });
  
      observer.observe(targetNode, { childList: true, subtree: true });
  }
  
  observeKlaviyoButton();

  function wrapButtons() {
      // Select elements that haven't been wrapped yet
      $('button.btn, .has-btn button, .has-btn .button, .has-btn .btn').each(function() {
          if (!$(this).parent().hasClass('st-btn')) {
              $(this).wrap("<div class='st-btn'></div>").after('<span></span>');
          }
      });
  }
  
  // Run the function initially for existing elements
  wrapButtons();
  
  // Example: Re-run the function after an AJAX call
  $(document).ajaxComplete(function() {
      wrapButtons();
  });
  
  $(document).on("click", ".toggle-sec", function(event) {
    const content = $(this).next('.collapsible-content');
    content.slideToggle(300, function() {
      if (content.is(":visible")) {
        $(event.target).addClass('active');
      } else {
        $(event.target).removeClass('active');
      }
    });
  });
  
  
  $('.submenu-toggle').on('click', function () {
    $(this).next('.blog-menu').slideToggle();
  });
  
  $(".list-collection__thumbnail").hover(
    function() {
      var btn=$(this).find('button');
      btn.text(btn.attr("data-hover-text"));
    }, 
    function() {
      var btn=$(this).find('button');
      btn.text(btn.attr("data-text"));
    }
  );

  // Cache the heights of sticky elements
  const topbarHeight = document.getElementById('announcement-bar')?.offsetHeight || 0;
  const mainmenuHeight = document.getElementById('header')?.offsetHeight || 0;
  const mobilemenuHeight = document.getElementById('mobile-header')?.offsetHeight || 0;
  const submenuHeight = Math.max(
    document.querySelector('.submenu')?.offsetHeight || 0,
    document.querySelector('.blog-menu')?.offsetHeight || 0
  );
  const stickyHeight = topbarHeight + mainmenuHeight + submenuHeight + mobilemenuHeight;
  
  // Smooth scroll to element
  function scrollToElem(hash) {
    const targetElement = document.querySelector(hash);
    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyHeight;
  
      // Modern browsers (smooth scrolling)
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
      // Fallback for older browsers
      else {
        $('html, body').animate({
          scrollTop: targetPosition
        }, 800);
      }
    }
  }
  // Prevent default hash scrolling and use custom scroll
  if (savedHash) {
    scrollToElem(savedHash); // Use custom scroll function
    //window.location.hash = savedHash; // Restore the hash after scrolling
  }

  $(document).on("click", ".mobile-menu .mobile-menu__item", function(event) {
    if (this.hash) {
      const elem = document.querySelector(this.hash);
      if (elem) {
        event.preventDefault();
        $(this).parent('label.submenu__label').click();
        $('.mobile-menu__toggle-button').click();
        $('.col-mobile-menu').parent().removeClass('open');
        scrollToElem(this.hash);
      }
    }
  });
  
  // sub menu smooth scroll
  $('.submenu a, .dropsubmenu a, .blog-menu a, .has-btn-scroll button, .has-btn-scroll a').on('click', function(event) {
    if (this.hash) {
      const elem = document.querySelector(this.hash);
      if (elem) {
        event.preventDefault();
        $('.col-mobile-menu').parent().removeClass('open');
        $(this).closest('.is-hoverable').removeClass('is-hoverable');
        scrollToElem(this.hash);
      }
    }
  });  
  /*
  $('.dropsubmenu a[href^="/collections#"]').on('click', function(event) {
    if (window.location.pathname === '/collections') {
        event.preventDefault();
        if (this.hash !== "") scrollToElem(this.hash);
    }
  });

  $('.blog-menu a').on('click', function(event) {
    if (window.location.pathname === '/pages/blog') {
        event.preventDefault();
        if (this.hash !== "") scrollToElem(this.hash);
    }
  });*/

  function updateVariantOptions($variantOptions) {
      const selectedValue = $variantOptions.attr('data-selected');
      $variantOptions.find('.variant-value').show();
      $variantOptions.find(`.variant-value[data-variantvalue="${selectedValue}"]`).hide();
      const $variantValues = $variantOptions.find('.variant-value:visible');
      $variantValues.removeClass('last-visible');
      $variantValues.last().addClass('last-visible');
      //$variantOptions.closest('.variant-type').removeClass('open');
      //$variantOptions.hide();
  }
  
  $('.variant-options').each(function () {
      updateVariantOptions($(this));
  });

  $(document).on('click', function(event) {
      if (!$(event.target).closest('.fc-form').length) {
        if($('body').hasClass('product') || $('body').hasClass('product-classic') || $('body').hasClass('product-scrolling')){
          $(this).find('.product__information .variant-options').hide();
          $(this).find('.product__information .variant-type').removeClass('open');
        }
        $(this).find('.flickity-slider .variants-container').hide();
        $(this).find('.flickity-slider .variant-options').hide();
        $(this).find('.flickity-slider .variant-type').removeClass('open');
        $(this).find(".flickity-slider .add-to-cart-btn").closest(".anim-btn").removeClass("state2");
        $(this).find(".flickity-slider .add-to-cart-btn").removeClass("btn-active");          
      }
  });
  $('.toggle-mobile-menu').on('click', function(event) {
      event.preventDefault();
      $(this).closest('.col-mobile-menu-wrapper').toggleClass('open');
  });
  
  $(document).on("click", ".toggle-button", function(event){  
    event.preventDefault();
    $('.extra-drawer').toggleClass('is-visible');
    $('.toggle-button').find('span').text($('.extra-drawer').hasClass('is-visible') ? 'Close Me' : 'Open Me' );
  });

  // Toggle variant options display
  $(document).on("click", ".variant-type", function(event) { 
    $('.variant-options').not($(this).find('.variant-options')).hide();
    $('.variant-type.open').not($(this)).removeClass('open');
    $(this).toggleClass('open');
    $(this).find('.variant-options').slideToggle('fast');
  });

  // Handle Add to Cart button click
  $(document).on("click", ".add-to-cart-btn", function(event) {  
    const me = $(this);
    const frm = me.closest('.fc-form');
    const state2 = me.hasClass('btn-active');
    $(".add-to-cart-btn").closest(".anim-btn").removeClass("state2");
    $(".add-to-cart-btn").removeClass("btn-active");
    $('.variants-container').not(frm.find('.variants-container')).slideUp();
      const nbv = me.closest('form').find('.variants-container').find('.variants-list .variant-type').length;
    if (!state2 && nbv > 0) {
      frm.find('.variants-container').slideToggle();
      me.closest(".anim-btn").toggleClass("state2");
      me.toggleClass("btn-active");
    } else {
      me.closest(".anim-btn").removeClass("state2");
      me.removeClass("btn-active");
      frm.find('.variants-container').slideUp();
      Shopify.theme.jsAjaxCart.addToCart(frm);
    }
  });

  function getSelectedVariant($product_form) {
    var variantId = $product_form.find('.select-container>select').val();
    var variant = $product_form.data('product').variants.find(variant => variant.id == variantId);
    return variant;
  }

  
    
  function handleInStock(variant) {
      $('.soldout-text').addClass('hidden');
      $('.atc').removeClass('hidden');
      if (!$('.fc-subscription').is(':visible')) {
          $('.product__information [data-add-to-cart-trigger]').show();
      }
      updatePrices(variant);
  }
  function handleOutOfStock() {
      $('.soldout-text').removeClass('hidden');
      $('.atc').addClass('hidden');
      $('.product__information [data-add-to-cart-trigger]').hide();
      $('.current_price').text('').removeClass('hidden');
      $('.was-price').text('0').hide();
  }

  $(document).on("click", ".variant-value", function(event) {
    event.stopPropagation();
    const me = $(this);
    const frm = me.closest('.fc-form');
    
    me.closest('.variant-options').hide();
    me.closest('.variant-type').removeClass('open');
    
    let selectedValue = me.attr('data-variantvalue');
    me.closest('.variant-options').attr('data-selected', selectedValue);
    me.closest('.variant-type').find('.variant-text').text(selectedValue);

    const selectedOptions = frm.find('>.variants-container .variant-options[data-selected]').map(function() {
        return $(this).attr('data-selected');
    }).get();
    const $variantSelect = frm.find('.select-container>select');
    let matchingVariantId = null;
    $variantSelect.find('option').each(function() {
        const optionValues = $(this).text().split(' / ');
        if (selectedOptions.every(selected => optionValues.includes(selected))) {
            matchingVariantId = $(this).val();
            return false;
        }
    });
    $variantSelect.val(matchingVariantId);
    $variantSelect.find('option[value="' + matchingVariantId + '"]').attr('selected','selected');
    frm.find('#variant-id').val(matchingVariantId);

    const url = new URL(window.location);
    url.searchParams.set('variant', matchingVariantId);
    window.history.pushState({}, '', url);

    let di = 'option'+(parseInt(me.closest('.variant-type').data('index')) + 1);
    $('select[data-option="'+di+'"]').val(selectedValue);
    $('.single-option-selector').trigger('change');
    
    if(frm.hasClass('fc-subscription')){
      me.closest('.variant-type').find('.variant-text').html(me.attr('data-variantname'));
      frm.find('.rc-selling-plans select').val(selectedValue);
      
    }

    if (me.closest('.variant-type').hasClass('variant-size')) {
      if (selectedValue === '100g') {
          $('.anim-subscription').hide();
          $('.addtocart').show();
      }
      else{
          $('.anim-subscription').show();      
      }
    }
    
    var variant = getSelectedVariant(me.closest('.product_form'));
    if (variant) {
        if (variant.available) {
            handleInStock(variant);
        } else {
            handleOutOfStock();
        }
    } else {
        handleOutOfStock();
    }

    updateVariantOptions(me.closest('.variant-options'));
  });

  function initValues(){
    if(!$('.product__information .product_form').length) return;
    const urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    $('.modal_price.subtitle>.sold_out').hide();
    $('.current_price').removeClass('hidden');
    
    if (null == variantId) {
      variantId = $('.product__information .select-container select[data-variant-selector]').find('option:first').val();
    }

    const variant = $('.product__information .product_form').data('product').variants.find(v => v.id == variantId);
    if (variant) {
      variant.options.forEach((optionValue, index) => {
        let selectElement = $(`.product__information .single-option-selector[data-option="option${index + 1}"]`);
        selectElement.val(optionValue).trigger('change');
        let customElement = $(`.product__information .variant-type[data-index="${index}"]`);
        customElement.find('.variant-text').text(optionValue);

        if (optionValue === '100g' && $(`.product__information .variant-type`).hasClass('variant-size')) {
            $('.anim-subscription').hide();
            $('.addtocart').show();
        }
        
        customElement.find('.variant-options').attr('data-selected',optionValue);
        updateVariantOptions(customElement.find('.variant-options'));        
      });

      if (variant.available) {
          handleInStock(variant);
      } else {
          handleOutOfStock();
      }
    } else {
        handleOutOfStock();
    } 
  }
  
  function updatePrices(variant){
    console.log(variant);
    
    //if(!variant) return;
    var newPrice = Shopify.formatMoney(variant.price, "${{amount}}");
    var oldPrice = Shopify.formatMoney(variant.compare_at_price, "${{amount}}");
    //console.log("Old Price:", oldPrice);
    //console.log("New Price:", newPrice);
    
    if ($('.fc-subscription').is(':visible')) {
    	planId=$('.product__information .rc-selling-plans select.rc-selling-plans__dropdown').val();
    	variant.selling_plan_allocations.forEach(item => {
    		if (item.selling_plan_id == planId) {
              newPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
              oldPrice = Shopify.formatMoney(item.compare_at_price, $('body').data('money-format'));
              $('.current_price').text(newPrice).removeClass('hidden').show();
              $('.was-price').text(oldPrice).show();
    		}
    	});	
    }    
    else{
      $('.current_price').text(newPrice).removeClass('hidden').show();
      if(!variant.compare_at_price) $('.was-price').text(oldPrice).hide();
      //$('.was-price').text(oldPrice);     
    }
  } 

  function waitForRechargeWidget() {
      return new Promise(function (resolve) {
          const checkWidgetLoaded = setInterval(function () {
              if (window.ReChargeWidget && window.ReChargeWidget.api) {
                  clearInterval(checkWidgetLoaded);
                  resolve();
              }
          }, 100);
      });
  }
  
  function fixSubscription(){
    waitForRechargeWidget().then(function () {
          // Step 1: Hide the select element
          var $select = $('.product__information').find('.product__information .rc-selling-plans select.rc-selling-plans__dropdown');
          //$select.hide();

            const selling_plan_groups = $('.product__information .product_form').data('product').selling_plan_groups[0];
            const sellingPlans = selling_plan_groups.selling_plans;
            //const container = document.querySelector('.rc-container');
            var formHtml = '';
          
            // Step 2: Loop through the options and generate HTML
            sellingPlans.forEach(function (plan) {
                formHtml += `
                    <div class="variant-value text-center" data-variantid="${plan.id}" data-variantname="${plan.name}" data-variantvalue="${plan.id}">
                        ${plan.name}
                    </div>`;
            });
          
            // Append the generated HTML to the DOM
            //$('.rc-container-wrapper').append($(formHtml));
            
            var observer = new MutationObserver(function (mutationsList, observer) {
                $variant_options=$('.fc-subscription .variant-options');
                if ($variant_options.length) {
                    $('.fc-subscription .variant-text').text(sellingPlans[0].name);
                    $variant_options.append($(formHtml));
                    $variant_options.attr('data-selected', sellingPlans[0].name);
                    updateVariantOptions($variant_options);
                    observer.disconnect();
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
            
          
            $(document).on('click', '.buy-subscription-btn', function() {
                me = $(this);
                //$('.ajax-submit').toggle();
                $('.atc').toggle();
                $('.fc-subscription').slideToggle(function() {
                  if ($('.fc-subscription').is(':visible')) {
                      $('.rc-option__subsave').click();
                  } else {
                      $('.rc-option__onetime').click()
                  }
                  $('.fc-subscription .variant-value:first-child').click();
                  var variant = getSelectedVariant(me.closest('.product__information .product_form'));
                  updatePrices(variant);
                });
            });
        
            // Step 3: Add click event for ".variant-value"
        
            // Step 4: Add click event for "add-to-cart-btn" to submit the form
            $(document).on('click', '.add-subscription-to-cart-btn', function() {
              //var $plan = $('.product__information .rc-selling-plans select.rc-selling-plans__dropdown');
              const variant = getSelectedVariant(me.closest('.product_form'));
              const planid = $('.fc-subscription').find('.variant-options').attr('data-selected');
              const plantext = $('.fc-subscription').find('.variant-text').text();
              addItemToCart(variant.id, $('.quantity-input').val(), planid, plantext);
            });          

    });
     
  }
  
  function addItemToCart(variant_id, qty, selling_plan, plan) {
    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": selling_plan,
       properties: {
        "plan": plan
      }
    }
    console.log('add to cart data');
    console.log(data);
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
          Shopify.theme.jsAjaxCart.updateView();
          Shopify.theme.jsAjaxCart.showDrawer();
      }
    });
  }

    function createInfiniteTicker(selector) {
        $(selector).each(function () {
            const $ticker = $(this);
            const $content = $('<div class="ticker-content"></div>');
            $ticker.children().appendTo($content);
            $ticker.append($content);
            $content.clone().appendTo($ticker);

            const contentWidth = $content.outerWidth();

            function startScrolling() {
                $ticker.find('.ticker-content').css({ left: 0 }).animate(
                    { left: -contentWidth },
                    contentWidth * 10, // Adjust speed
                    'linear',
                    function () {
                        $(this).css({ left: contentWidth });
                        startScrolling(); // Recursive call for seamless looping
                    }
                );
            }

            $ticker.hover(
                function () {
                    $ticker.find('.ticker-content').stop(true); // Pause scrolling
                },
                function () {
                    startScrolling(); // Resume scrolling
                }
            );

            if (contentWidth > $ticker.width()) startScrolling();
        });
    }


    jQuery(document).on("click", ".container .show-more-content", function(event) {
      jQuery(this).toggleClass('open');
      jQuery(this).closest('.container').find('.image-with-text__text-column').slideToggle();
      event.stopPropagation(); 
    });
  /*
    jQuery(document).on("click", ".mixed-content .show-more-content", function(event) {
      const me = jQuery(this);
      const mixedContent = me.closest('.mixed-content');
      const cellContent = mixedContent.find('.cell-content');
      
      me.toggleClass('open');
      cellContent.slideToggle(300, function() {
        // Calculate the new height of the slide
        const newHeight = mixedContent.outerHeight(true);
    
        // Manually set the height of the viewport
        const flickitySlider = me.closest('.flickity-viewport');
        flickitySlider.height(newHeight);
    
        // Recalculate Flickity dimensions
        const flickityInstance = me.closest('.carousel').data('flickity');
        if (flickityInstance) {
          flickityInstance.resize();
        }
      });
    
      event.stopPropagation();
    });
  */
  /*
  jQuery(document).on("click", ".mixed-content .show-more-content", function(event) {
    const me = jQuery(this);
    const mixedContent = me.closest('.mixed-content');
    const cellContent = mixedContent.find('.cell-content');

    const isExpanded = me.hasClass('open');

    var newHeight = mixedContent.outerHeight(true);

    const flickitySlider = me.closest('.main-flickity-slider');
    if(!isExpanded){
      const clonedContent = cellContent.clone().css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block'
      }).appendTo(mixedContent);
    
      newHeight = mixedContent.outerHeight(true) + clonedContent.outerHeight(true);
      clonedContent.remove();

      flickitySlider.height(newHeight);
      me.toggleClass('open');
      cellContent.slideToggle();
      
    }
    else{
      newHeight = mixedContent.outerHeight(true) - cellContent.outerHeight(true);      
      me.toggleClass('open');
      cellContent.slideToggle(300, function(){flickitySlider.height(newHeight);});  
    }
  
    event.stopPropagation();
  });*/
  
  if($('.product__information .custom-widget').length) fixSubscription();
  createInfiniteTicker('.ticker');
  initValues();
  window.rechargeCustomTheme = {
    selectors: {
      price: ['.rc-price']
    }
  };  
});
 

// Function containing the core logic
function handlePackagingChange(event) {
    const target = event.target;
    if (!target.matches('.packaging-option')) {
        return;
    }

    const packagingContainer = target.closest('.box-type');
    if (!packagingContainer) return;

    const giftWrapVariantId = packagingContainer.getAttribute('data-gift-wrap-variant-id');
    const packagingOptions = packagingContainer.querySelectorAll('.packaging-option');

    if (!giftWrapVariantId) {
        console.error("Gift Wrap Variant ID is missing in the box-type container.");
        return;
    }

    const selectedValue = target.value;
    let body = {};
    let url = '';
    
    // Disable inputs while processing
    packagingOptions.forEach(opt => opt.disabled = true); 

    if (selectedValue === 'Gift Wrapping') {
      url = '/cart/add.js';
      body = { items: [{ id: giftWrapVariantId, quantity: 1 }] };
    } else {
      url = '/cart/change.js';
      body = { id: giftWrapVariantId, quantity: 0 }; 
    }
    
    fetch(url, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify(body)
    })
    .then(response => {
      if (!response.ok) {
          return response.json().then(errorData => {
              throw new Error(`Cart update failed: ${response.status} - ${errorData.message || 'Unknown Shopify API error'}`);
          });
      }
      return response.json(); 
    })
    .then(() => {
        Shopify.theme.jsAjaxCart.updateView();

        // Re-enable options after refresh attempt
        packagingOptions.forEach(opt => opt.disabled = false); 
    })
    .catch(error => {
      console.error('Final Error updating cart:', error);
      packagingOptions.forEach(opt => opt.disabled = false); 
    });
}

// === Event Delegation Setup ===
// Attach a single, permanent listener to the document.
document.addEventListener('change', handlePackagingChange);